import './ConversationPlayer.css';
import { useState, useEffect, useRef } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import storage from '/src/utils/storage';
import TimelineRow from '../TimelineRow/TimelineRow';
import { useAnimationBlock } from './hooks/useAnimationBlock';
import ConversationCompletedService from '/src/features/supervision/conversations/services/ConversationCompletedService';
import hasPermission from '/src/utils/hasPermission';
//const getAudioUrl = (conversationId, objectId, download= false) => `${env.REACT_APP_API_PATH}/conversation/completed/${conversationId}/audio?object_id=${objectId}&download=${download}&token_auth=${storage('local').get('token')}`;

const ConversationPlayer = ({ conversation, audioRef, setCurrentTimeAudio }) => {
    const containerRef = useRef(null);
    const [blobUrl, setBlobUrl] = useState(null);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const { getConversationAudio } = ConversationCompletedService;
    const [conversation_data, setConversationData] = useState(conversation.content);
    const { animationBlock, rotateChevron, openBlock } = useAnimationBlock();
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [loadingAudio, setLoadingAudio] = useState(true);
    const [selectedSpeed, setSelectedSpeed] = useState(1);
    const currentUser = storage('local').get('user');
    const canExportConversationData = currentUser?.is_admin || hasPermission('export_conversation_data');

    const updateCurrentTime = () => {
        if (audioRef == null || audioRef.current == null) return;
        const audio = audioRef.current.audio.current;
        setCurrentTime(audio.currentTime);
        setCurrentTimeAudio(audio.currentTime)
    };
    const rotate = rotateChevron ? "close_style" : "open_style"

    const changeSpeed = (rate) => {
        if (!audioRef?.current?.audio?.current) return;
        audioRef.current.audio.current.playbackRate = rate;
        setSelectedSpeed(rate);
    };

    useEffect(() => {
        let active = true;
        let objectUrl = null;

        const loadBlob = async () => {
            setLoadingAudio(true);
            const [response, error] = await getConversationAudio({
                call_id: conversation.call_id
            });

            if (error || !response) {
                setLoadingAudio(false);
                return;
            }

            const blob = new Blob([response], { type: "audio/wav" });

            objectUrl = URL.createObjectURL(blob);

            if (active) {
                setBlobUrl(objectUrl);
            }
        };

        loadBlob();

        return () => {
            active = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [conversation.call_id]);


    //if (!blobUrl) return null; A REMETTRE APRES LES TESTS

    // <AudioSource className="audio_src_conversation_information_modal" picture={false} src={getAudioUrl(data.id, data.audio_object_id)} downloadUrl={getAudioUrl(data.id, data.audio_object_id,true)}/> : null}
    useEffect(() => {
        if (!blobUrl) return;

        const audio = new Audio(blobUrl);
        audio.preload = "metadata";

        audio.onloadedmetadata = () => {
            setLoadingAudio(false);
            setDuration(audio.duration);
        };
        setDownloadUrl(blobUrl);
        return () => {
            audio.src = "";
        };
    }, [blobUrl]);

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        const updateHeight = () => {
            document.documentElement.style.setProperty('--conversation-player-height', `${el.offsetHeight}px`);
        };

        updateHeight();
        const observer = new ResizeObserver(updateHeight);
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (

        <div ref={containerRef} className={"conversation-player-container " + (rotateChevron == false ? "conversation-player-open" : "")}>
            {loadingAudio ? (
                <div className="audio-loader">
                    <i className="fas fa-spinner fa-spin"></i>
                    <span>Loading audio...</span>
                </div>
            ) : (<>
                <div className={"conversation-player-title " + (rotateChevron == false ? 'conversation-player-title-opened' : "")} onClick={() => { openBlock() }}>
                    <IconButton onClick={() => { openBlock() }} className="main-iconButton profil_action main_add-button space_tableButton block_button" icon={"fas fa-chevron-right " + rotate} key={'buttonOpen'} />
                    <span ><h2>Key moments</h2> </span>
                </div>

                <div className={animationBlock}>

                    <div className={"audio-container "} >
                        <AudioPlayer src={downloadUrl} autoPlay={false} ref={audioRef} onListen={updateCurrentTime} />
                        {/* download button */}
                        {canExportConversationData ?
                            <div className="download_button_container">
                                <a href={downloadUrl} className="download_audio_source" download >
                                    <IconButton icon={"fas fa-download"} className="download_button_audio" />
                                </a>
                            </div> : (rotateChevron == false ? <br></br> : null)
                        }
                        <div className="audio_speed_parameters">
                            <div className={`audio_speed_player ${selectedSpeed === 1 ? "active" : ""}`} onClick={() => changeSpeed(1)} >1x</div>
                            <div className={`audio_speed_player ${selectedSpeed === 1.5 ? "active" : ""}`} onClick={() => changeSpeed(1.5)}>1.5x</div>
                            <div className={`audio_speed_player ${selectedSpeed === 2 ? "active" : ""}`} onClick={() => changeSpeed(2)}>2x</div>
                        </div>
                    </div>
                    <div className="timeline">
                        <TimelineRow label="Client" lines={conversation_data.left} duration={duration} audioRef={audioRef} currentTime={currentTime} showCriteria={false} />
                        <TimelineRow label="Agent" lines={conversation_data.right} duration={duration} audioRef={audioRef} currentTime={currentTime} />
                    </div>
                </div>
            </>)}
        </div>
    )
};


export default ConversationPlayer;


